import CalculatorsController from '../../src/javascripts/cvm';
import AgilityRecovery from '../../src/javascripts/models/agility/recovery';
import '../../src/javascripts/helpers/application/fa_checkbox_helper';
// import '../../src/javascripts/helpers/application/self_service_pdf_launcher';
import '../../src/javascripts/helpers/agility/pardot_helper';
import '../../src/javascripts/helpers/agility/recovery/product_dependencies';
import '../../src/stylesheets/agility/recovery.scss';
import '../../src/stylesheets/agility/recovery-pardot.css';

(function() {
  $(() => CalculatorsController.run(new AgilityRecovery()));
}).call(this);
